import { initContract } from '@ts-rest/core';
import { z } from 'zod';
const c = initContract();
/** Mirrors the backend `OperatorView` (catalog domain). */
export const OperatorSchema = z.object({
    id: z.string(),
    name: z.string(),
    availableTypes: z.array(z.enum(['classic', 'dataonly'])),
});
export const operatorContract = c.router({
    listOperators: {
        method: 'GET',
        path: '/operators',
        responses: {
            200: z.array(OperatorSchema),
        },
        summary: 'List the telecom operators',
    },
});
